import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthModal from './AuthModal';
import './Nav.css';

export default function Nav() {
  const { user, profile, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [authModal, setAuthModal] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const navigate = useNavigate();

  function handleSignOut() {
    signOut();
    setUserMenuOpen(false);
    navigate('/');
  }

  return (
    <>
      <nav className="nav">
        <Link to="/" className="nav-logo">
          homes<span>4bid</span>
        </Link>

        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/search" onClick={() => setMenuOpen(false)}>buy</Link>
          <Link to="/search?mode=rent" onClick={() => setMenuOpen(false)}>rent</Link>
          {user && <Link to="/buyer-dashboard" onClick={() => setMenuOpen(false)}>my bids</Link>}
          <Link to="/home-prospector" className="nav-link-featured" onClick={() => setMenuOpen(false)}>HomeProspector™</Link>
          {user && <Link to="/shortlist" onClick={() => setMenuOpen(false)}>for you</Link>}
          {user && <Link to="/owner-dashboard" onClick={() => setMenuOpen(false)}>owner</Link>}
          <Link to="/faq" onClick={() => setMenuOpen(false)}>FAQ</Link>
        </div>

        <div className="nav-actions">
          {user ? (
            <div className="user-menu-wrap">
              <button className="user-btn" onClick={() => setUserMenuOpen(!userMenuOpen)}>
                <div className="user-avatar">
                  {(profile?.full_name || user.email)?.[0]?.toUpperCase()}
                </div>
                <span className="user-name">
                  {profile?.full_name?.split(' ')[0] || 'account'}
                </span>
              </button>
              {userMenuOpen && (
                <div className="user-dropdown">
                  <div className="user-dropdown-email">{user.email}</div>
                  <Link to="/buyer-dashboard" onClick={() => setUserMenuOpen(false)}>my bids</Link>
                  <Link to="/shortlist" onClick={() => setUserMenuOpen(false)}>for you</Link>
                  <Link to="/owner-dashboard" onClick={() => setUserMenuOpen(false)}>owner dashboard</Link>
                  <Link to="/owner-list" onClick={() => setUserMenuOpen(false)}>list my home</Link>
                  <Link to="/account" onClick={() => setUserMenuOpen(false)}>account settings</Link>
                  {user.email === 'bentleyesam@gmail.com' && (
                    <Link to="/admin/waitlist" onClick={() => setUserMenuOpen(false)}>waitlist admin</Link>
                  )}
                  <div className="dropdown-divider" />
                  <button onClick={handleSignOut}>sign out</button>
                </div>
              )}
            </div>
          ) : (
            <>
              <button className="btn btn-sm" onClick={() => setAuthModal('signin')}>sign in</button>
              <button className="btn btn-primary btn-sm" onClick={() => setAuthModal('signup')}>get started</button>
              <button className="btn btn-primary btn-sm" style={{ marginLeft: 4 }} onClick={() => navigate('/owner-list')}>list my home</button>
            </>
          )}
        </div>

        <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span /><span /><span />
        </button>
      </nav>

      {authModal && (
        <AuthModal defaultMode={authModal} onClose={() => setAuthModal(null)} />
      )}
    </>
  );
}
